// Module
var code = "<div class=\"headers-editor variables-editor\">\n  <variables-editor ng-model=\"headers\" key=\"name\" value=\"value\"></variables-editor>\n</div>\n";
// Exports
module.exports = code;